<template>
    <jet-action-section>
        <template #title>
            Autenticação por dois fatores
        </template>

        <template #description>
            <p class="mb-6">Precisa de ajuda? Veja o passo a passo abaixo!</p>

            <p class="mb-6"><span class="text-lg font-bold">Passo 1</span><br/>
                Clique no botão "Habilitar" para iniciar o processo e confirme novamente sua senha.</p>

            <p class="mb-6"><span class="text-lg font-bold">Passo 2</span><br/>
                Em seu celular, baixe o aplicativo "Twilio Authy" ou o "Google Authenticator".
                <br/>
                <br/>
                <img src="/images/authy-auth.png" width="100"/>
                <br/>
                Nota:<br/>
                --- Se o seu dispositivo é Android, procure pelo aplicativo de sua escolha em "Google Play".<br/>
                --- Se o seu dispoitivo é iOS (iPhone), procure pelo aplicativo de sua escolha em "App Store".<br/>
                <br/>

            </p>

            <p class="mb-6"><span class="text-lg font-bold">Passo 3</span><br/>
                No aplicativo em seu celular, leia ou escaneie o código QR gerado aqui no portal e em seguida digite no
                campo logo abaixo o código de 6 dígitos informado pelo aplicativo.</p>

            <p class="mb-6"><span class="text-lg font-bold">Passo 4</span><br/>
                Clique no botão "Confirmar código".</p>

            <p class="mb-6">
                Tudo pronto!
            </p>
        </template>

        <template #content>
            <h3 class="text-lg font-medium text-gray-900" v-if="twoFactorEnabled">
                Autenticação por 2 fatores habilitada.
            </h3>

            <h3 class="text-lg font-medium text-gray-900" v-else>
                Autenticação por 2 fatores não habilitada.
            </h3>

            <div class="mt-3 max-w-xl text-sm text-gray-600" v-if="$page.props.user.two_factor_confirmed">
                Clique no botão "EXIBIR CÓDIGOS DE RECUPERAÇÃO" e guarde estes códigos. Em caso de problemas com suas
                credenciais, você pode utilizá-los para novamente garantir seu acesso.
                <br/>
                <br/>
                Você tem a opção de desabilitar a Autenticação por 2 Fatores mas atenção: você não poderá navegar neste
                portal até que seja habilitada novamente.
            </div>

            <div class="mt-3 max-w-xl text-sm text-gray-600" v-else>
                Para navegar neste portal é obrigatório que habilite a Autenticação por 2 Fatores (2FA).
                O procedimento é simples, basta seguir o passo a passo à esquerda.
            </div>

            <div v-if="twoFactorEnabled">
                <div v-if="qrCode">
                    <div class="mt-4" v-html="qrCode">
                    </div>
                </div>

                <div v-if="recoveryCodes.length > 0">
                    <div class="mt-4 max-w-xl text-sm text-gray-600">
                        Guarde os códigos abaixo em um local seguro. Eles poderão ser utilizados para acessar
                        sua conta caso você perca acesso ao seu aplicativo de autenticação.
                    </div>

                    <div class="grid gap-1 max-w-xl mt-4 px-4 py-4 font-mono text-sm bg-gray-100 rounded-lg">
                        <div v-for="code in recoveryCodes">
                            {{ code }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-5">
                <div v-if="! twoFactorEnabled">
                    <jet-confirms-password @confirmed="enableTwoFactorAuthentication">
                        <jet-button type="button" :class="{ 'opacity-25': enabling }" :disabled="enabling">
                            Habilitar
                        </jet-button>
                    </jet-confirms-password>
                </div>
                <div v-else-if="!$page.props.user.two_factor_confirmed">
                    <div class="col-span-3 sm:col-span-4 w-1/2 mb-6">
                        <jet-label for="two_factor_code" value="Informe um código de autorização"/>
                        <jet-input id="two_factor_code" type="number" class="mt-1 block w-full"
                                   v-model="form.two_factor_code" ref="two_factor_code"/>
                        <jet-input-error :message="form.error('two_factor_code')" class="mt-2"/>
                    </div>

                    <jet-ok-button class="mr-3" @click.native="confirmTwoFactorCode">
                        Confirmar código
                    </jet-ok-button>
                </div>
                <div v-else>
                    <jet-confirms-password @confirmed="regenerateRecoveryCodes">
                        <jet-secondary-button class="mr-3"
                                              v-if="recoveryCodes.length > 0">
                            Criar novos códiogs de recuperação
                        </jet-secondary-button>
                    </jet-confirms-password>

                    <jet-confirms-password @confirmed="showRecoveryCodes">
                        <jet-secondary-button class="mr-3" v-if="recoveryCodes.length == 0">
                            Exibir códigos de recuperação
                        </jet-secondary-button>
                    </jet-confirms-password>

                    <jet-confirms-password @confirmed="disableTwoFactorAuthentication">
                        <jet-danger-button
                            :class="{ 'opacity-25': disabling }"
                            :disabled="disabling">
                            Desabilitar
                        </jet-danger-button>
                    </jet-confirms-password>
                </div>
            </div>
        </template>
    </jet-action-section>
</template>

<script>
import JetActionSection from './../../Jetstream/ActionSection'
import JetButton from './../../Jetstream/Button'
import JetConfirmsPassword from './../../Jetstream/ConfirmsPassword'
import JetDangerButton from './../../Jetstream/DangerButton'
import JetSecondaryButton from './../../Jetstream/SecondaryButton'
import JetInput from "../../Jetstream/Input";
import JetInputError from "../../Jetstream/InputError";
import JetLabel from "../../Jetstream/Label";
import JetOkButton from "../../Jetstream/OkButton";

export default {
    components: {
        JetActionSection,
        JetButton,
        JetConfirmsPassword,
        JetDangerButton,
        JetSecondaryButton,
        JetInput,
        JetInputError,
        JetLabel,
        JetOkButton,
    },

    data() {
        return {
            enabling: false,
            disabling: false,
            qrCode: null,
            recoveryCodes: [],
            form: this.$inertia.form({
                two_factor_code: '',
            }),
        }
    },

    methods: {
        confirmTwoFactorCode() {
            this.form.post(route('user-two-factor.confirm'), {
                preserveScroll: true
            }).then(() => {

            })
        },
        enableTwoFactorAuthentication() {
            this.enabling = true

            this.$inertia.post('/user/two-factor-authentication', {}, {
                preserveScroll: true,
            }).then(() => {
                return Promise.all([
                    this.showQrCode()
                ])
            }).then(() => {
                this.enabling = false
            })
        },

        showQrCode() {
            return axios.get('/user/two-factor-qr-code')
                .then(response => {
                    this.qrCode = response.data.svg
                })
        },

        showRecoveryCodes() {
            return axios.get('/user/two-factor-recovery-codes')
                .then(response => {
                    this.recoveryCodes = response.data
                })
        },

        regenerateRecoveryCodes() {
            axios.post('/user/two-factor-recovery-codes')
                .then(response => {
                    this.showRecoveryCodes()
                })
        },

        disableTwoFactorAuthentication() {
            this.disabling = true

            this.$inertia.delete('/user/two-factor-authentication', {
                preserveScroll: true,
            }).then(() => {
                this.disabling = false
            })
        },
    },

    computed: {
        twoFactorEnabled() {
            if (this.$page.props.user.two_factor_enabled && !this.$page.props.user.two_factor_confirmed) {
                this.showQrCode();
            }
            return !this.enabling && this.$page.props.user.two_factor_enabled
        }
    }
}
</script>
